import { render, staticRenderFns } from "./CustomVideo.vue?vue&type=template&id=5f9d734f&scoped=true&lang=pug"
import script from "./CustomVideo.vue?vue&type=script&lang=js"
export * from "./CustomVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9d734f",
  null
  
)

export default component.exports